import { render, staticRenderFns } from "./TableBudgetDiagnosis.vue?vue&type=template&id=2133c788&scoped=true&"
import script from "./TableBudgetDiagnosis.vue?vue&type=script&lang=js&"
export * from "./TableBudgetDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetDiagnosis.vue?vue&type=style&index=0&id=2133c788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133c788",
  null
  
)

export default component.exports